import { CSSProperties } from "react";
import { Form } from "antd";
import styled from "styled-components";
import theme from "styles/theme";

const { Item } = Form;

export const FormItem = styled(Item)`
  .ant-input {
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: ${(props) => props.theme["@normal-font-weight"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
    margin-left: 0;
    &:hover,
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }

  .ant-input-affix-wrapper {
    border: 1.6px solid ${(props) => props.theme.colors.manatee};
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: ${(props) => props.theme["@normal-font-weight"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
    &:hover,
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }
  .ant-form-item-label {
    min-width: 100%;
    max-width: 100%;
    z-index: 1;
    max-height: 28px;
    height: 28px;
    align-items: center;
  }

  .ant-col.ant-form-item-label > label.ant-form-item-required:hover {
    pointer-events: none !important;
  }

  .ant-form-item-label > label {
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: ${(props) => props.theme["@normal-font-weight"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
    pointer-events: none !important;
  }

  .ant-form-item {
    margin-bottom: 5px !important;
  }
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 1px solid ${(props) => props.theme.colors.manatee};
  }

  .ant-form-item-required::before {
    content: "" !important;
  }

  .ant-form-item-required {
    width: 100%;
    align-items: center;
  }
  .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
    margin-right: 0;
    align-items: center !important;
    margin-bottom: -8px !important;
    content: "" !important;
  }

  .ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector,
  .ant-input[disabled] {
    background: ${(props) => props.theme["@input-background-disabled"]};
    color: ${(props) => props.theme["@profile-text-color"]};
    cursor: default;
    :hover {
      background-color: ${(props) => props.theme["@input-background-disabled"]} !important;
    }
  }

  .ant-input.ant-input-status-error {
    border: 1.6px solid ${(props) => props.theme["@danger-color"]} !important;
    background-color: ${(props) => props.theme["@danger-background"]};
    :hover {
      border-color: ${(props) => props.theme["@danger-color"]};
      background-color: ${(props) => props.theme["@danger-background"]} !important;
    }
    .ant-input {
      background-color: ${(props) => props.theme["@danger-background"]};
      :hover {
        border-color: ${(props) => props.theme["@danger-color"]};
        background-color: ${(props) => props.theme["@danger-background"]} !important;
      }
    }
  }

  .ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input {
    background-color: ${(props) => props.theme["@danger-background"]} !important;
  }

  .ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector,
  .ant-input[disabled] {
    background: ${(props) => props.theme["@input-background-disabled"]};
    color: ${(props) => props.theme["@profile-text-color"]};
    cursor: default;
  }

  .ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector:hover .ant-input[disabled]:hover {
    border: none !important;
  }

  .ant-input-affix-wrapper-disabled,
  .ant-input-disabled {
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:active,
    input:-webkit-autofill:focus {
      background-color: ${(props) => props.theme["@input-background-disabled"]} !important;
      color: ${(props) => props.theme["@secondary-color"]} !important;
      box-shadow: 0 0 0 1000px ${(props) => props.theme["@input-background-disabled"]} inset !important;
      -webkit-box-shadow: 0 0 0 1000px ${(props) => props.theme["@input-background-disabled"]} inset !important;
    }
    :hover {
      border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
      background-color: ${(props) => props.theme["@input-background-disabled"]} !important;
      cursor: default;
      > input {
        background-color: ${(props) => props.theme["@input-background-disabled"]} !important;
        border: none !important;
      }
    }
  }
`;

export const DriversField: CSSProperties = {
  width: "100%",
  paddingTop: "7px",
};

export const InputDriver: CSSProperties = {
  height: theme["@height-input-lg"],
};

export const FormDrivers = styled.div`
  display: grid;
  grid-template-columns: 2fr 1.6fr;
  grid-column-gap: 3px;
`;

export const InputCpf: CSSProperties = {
  height: theme["@height-input-lg"],
};

export const CpfField: CSSProperties = {
  width: "100%",
  paddingTop: "7px",
};
